import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const TiersContext = createContext(null);

export const TiersProvider = ({ children }) => {
  const [tiers, setTiers] = useState(null);

  useEffect(() => {
    api.get('/tiers').then(res => setTiers(res.data.result)).catch(() => {});
  }, []);

  return (
    <TiersContext.Provider value={tiers}>
      {children}
    </TiersContext.Provider>
  );
};

export const useTiers = () => useContext(TiersContext);
